var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header'),_c('p',{staticStyle:{"margin-top":"100px","margin-left":"100px"}},[_vm._v(_vm._s(_vm.$t("home.home-18")))]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }